import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { FilterField } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface SetFieldFilterParams {
  id?: string;
  fields?: FilterField[];
  isOrganization: boolean;
  name: string;
}

const setFieldFilter: MutationFunction<
  SetFieldFilterParams,
  SetFieldFilterParams
> = async (args) => {
  if (isMockServices())
    return await mock(_mockFieldFilter(args), { delay: 4000, failureRate: 1 });
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SetFieldFilterParams>(
    args.id ? `/search-filters/${args.id}` : '/search-filters',
    {
      method: args.id ? 'PUT' : 'POST',
      body: {
        type: 'field',
        visibility: args.isOrganization ? 'public' : 'private',
        configuration: {
          fieldIds: args.fields,
        },
        name: args.name,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set field filter');
};

export default setFieldFilter;

const _mockFieldFilter = (stackFilter: SetFieldFilterParams) => {
  return {
    id: crypto.randomUUID(),
    ...stackFilter,
  };
};
